export default "__VITE_ASSET__87af9773__"